import React from 'react';
import DefaultPage from 'jsx/pages/default';
import Backbone from 'backbone';
import AdvertMixin from 'js/mixins/adverts';
import EmptyLayout from 'jsx/layouts/empty';
import store from 'flux/instance';
import cookieControl from '../js/cookieControl';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

const inputTypes = [
  'text',
  'email',
  'search',
  'url',
  'tel',
  'number',
];

const App = createReactClass({
  propTypes: {
    app: PropTypes.object.isRequired,
  },

  /**
   * Context types
   */
  childContextTypes: {
    store: PropTypes.any,
    app: PropTypes.any.isRequired,
    page: PropTypes.any,
    tracking: PropTypes.object,
  },

  mixins: [AdvertMixin],

  getInitialState: function() {
    return {
      page: DefaultPage,
      pageData: { layout: EmptyLayout },
      hideSidebar: true,
      modularView: false,
      modal: null, // or modal instance
      alert: null, // or alert instance
      unreadMessages: 0,
      unreadNotifications: 0,
      inputFocused: false,
    };
  },

  /**
   * Share context
   */
  getChildContext: function() {
    return {
      store,
      app: this.props.app,
      page: {
        getType: this.props.app.context.getType.bind(this.props.app.context),
        getGroup: this.props.app.context.getGroup.bind(this.props.app.context),
      },
      tracking: this.props.app.state ? this.props.app.state.data.tracking : {},
    };
  },

  /**
   * When dom is inserted
   */
  componentDidMount: function() {
    cookieControl();

    Backbone.on('view:toggleSidebar', this.toggleSidebar, this);
    Backbone.on('view:hideSidebar', this.hideSidebar, this);

    // Used by Google Ad Manager creative template snippet for adverts, see AdvertMixin
    // It's triggered when the ad is displayed
    Backbone.on('popup:added', this.togglePopup, this);

    // To stick the footer to the bottom when there is not much content we use a little hackery
    // hardcoded style value which basically accounts for min footer height and sitebar height
    const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - 326;
    const css = '.body-container { min-height: ' + height + 'px; }';

    let head = document.head || document.getElementsByTagName('head')[0];
    let style = document.createElement('style');
    style.type = 'text/css';

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
  },

  /**
   * Before dom is removed
   */
  componentWillUnmount: function() {
    Backbone.off('view:toggleSidebar', this.toggleSidebar, this);
    Backbone.off('view:hideSidebar', this.hideSidebar, this);
  },

  /**
   * Toggle whether sidebar is hidden or not
   */
  toggleSidebar: function() {
    this.setState({
      hideSidebar: !this.state.hideSidebar,
    });
  },

  /**
   * Force hide the sidebar
   */
  hideSidebar: function() {
    if (this.state.hideSidebar) {
      return;
    }

    this.setState({
      hideSidebar: true,
    });
  },

  /**
   * Is the given node an input?
   * NOTE: Definition of an input here is a control users
   *       can type into Ie. input or textarea
   */
  isInput: function(node) {
    var tagName = node.tagName.toUpperCase();
    var type = node.getAttribute('type');

    return (tagName === 'INPUT' && (!type || inputTypes.indexOf(type) > -1)) || tagName === 'TEXTAREA';
  },

  /**
   * When a focus event propagates
   */
  onFocusCapture: function(e) {
    if (this.isInput(e.target)) {
      this.setState({inputFocused: true});
    }
  },

  /**
   * When a blur event propagates
   */
  onBlurCapture: function(e) {
    if (this.isInput(e.target)) {
      this.setState({inputFocused: false});
    }
  },

  /**
   * When a form is submitted we should remove the inputFocussed state
   * (thus allowing the top bar to be show on ios mobile)
   */
  onSubmit: function() {
    if (this.state.inputFocused) {
      this.setState({inputFocused: false});
    }
  },

  render() {
    const Layout = this.state.pageData.layout || EmptyLayout;
    return (
      <div>
        <Layout
          page={this.state.page}
          pageData={this.state.pageData}
          hideSidebar={this.state.hideSidebar}
          modularView={this.state.modularView}
          ref="layout"
          modal={this.state.modal}
          alert={this.state.alert}
          inputFocused={this.state.inputFocused}
          onFocusCapture={this.onFocusCapture}
          onBlurCapture={this.onBlurCapture}
          onSubmit={this.onSubmit}
          unreadMessages={this.state.unreadMessages}
          unreadNotifications={this.state.unreadNotifications}
        />
        {/* Google Ad Manager ads on all pages */}
        <div id="gpt-ad-1" />
        <div id="gpt-ad-2" />
      </div>
    );
  },
});

export default App;



// WEBPACK FOOTER //
// ./app/assets/jsx/app.jsx